// notemix code, 不显示导航菜单按钮
//import { Button } from '@affine/component/ui/button';
//import { useI18n } from '@affine/i18n';
// notemix code, 更换主页链接图标
import { HomeIcon } from '@blocksuite/icons/rc';
//import { Logo1Icon } from '@blocksuite/icons/rc';
import { useTheme } from 'next-themes';
// notemix code, 不显示导航菜单按钮
import { type ReactNode } from 'react';

//import { type ReactNode, useCallback } from 'react';
import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
//notemix code, 不显示导航菜单按钮
//import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
//notemix code, 不显示导航菜单按钮
//import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  /*notemix code, 不显示导航菜单按钮
  const t = useI18n();
  
  const openDownloadLink = useCallback(() => {
    open(BUILD_CONFIG.downloadUrl, '_blank');
  }, []);
  */

  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.affineLogo}>
            {/* notemix code, 更换主页链接图标
            <Logo1Icon width={24} height={24} />
            */}
            <HomeIcon width={24} height={24} />
          </a>
          {/* notemix code, 不显示官方导航菜单按钮
          <DesktopNavbar />
          <Button
            onClick={openDownloadLink}
            className={styles.hideInSmallScreen}
          >
            {t['com.affine.auth.open.affine.download-app']()}
          </Button>
          <MobileNavbar />
          */}
        </div>
      )}

      {children}
    </div>
  );
};
